<template>
	<div class="inline-flyer-selector" 
	:class="dynamicClasses" 
	v-bind="config.attrs" v-click-outside="autoClose">
		<config-style-injector :root-selector="`.inline-flyer-selector`" :config="config" />
		<div class="flyer-list" :class="{ open: showList }">
			<flyer-thumb-list />
		</div>
		   <component :is="flyerSelectorTemplate" :autofocus="autofocus" />
	</div>
</template>

<script>
import featureMixin from "@/mixins/featureMixin";
import ConfigStyleInjector from "@/components/style-injector/ConfigStyleInjector.vue";
import FlyerThumbList from "@/features/flyer-selector/FlyerThumbList.vue";
import InlineFlyerSelectorDefault from "@/features/flyer-selector/inline/InlineFlyerSelectorDefault.vue"
import InlineFlyerSelectorCTC from "@/features/flyer-selector/inline/InlineFlyerSelectorCTC.vue"
import Lytics from "@/classes/Lytics";
import { mapGetters, mapState } from "vuex";
import AppConfig from "@/classes/AppConfig";

export default {
	name: "InlineFlyerSelector",
	components: {FlyerThumbList, ConfigStyleInjector},
	mixins:[featureMixin],
	props: {
		autofocus: {
			type: Boolean,
			default: false
		}
	},
	data(){
		return {
			featurePath: 'flyerSelector',
			impressionFired: false,
			isHidden: false,
			lastScrollPosition: 0,
		}
	},
	mounted() {
        if (this._config.isVisibleByPub) {
             if  (this.sortedFlyers.length <= 1) {
                 this._config.isVisible = false
             }  
        }
    },
	created() {
   if(this.config.position==='top' && this.config._flyerOrientation['+vertical'].defaultVisibility !== undefined)
     this._config.isVisible = this.config._flyerOrientation['+vertical']?.defaultVisibility;
   else
     this._config.isVisible = true

    if(this.config.defaultVisibility !== undefined && !this._config.__hasLoaded) {
			this._config.isVisible = this.config.defaultVisibility;
		}
		this._config.__hasLoaded = true;
	},
	computed:{
		...mapGetters('landingPage', ['sortedFlyers', 'currentFlyer']),
		...mapGetters('raddar', ['isRaddar']),
		...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		...mapState('scale', ['scrollY']),
		...mapState('drawer', ['drawerItems']),
		 ...mapGetters("inlineDrawers", ["isFlyerOpen","isFilterOpen"]),
		templates() {
      return {
        ctc: InlineFlyerSelectorCTC,
        default: InlineFlyerSelectorDefault
      };
    },
	dynamicClasses() {
		return [
			this.config.position,
			this.isCompactView ? 'compact-view': '',
			this.isVertical ? 'vertical': '',
			this.isMobile ? 'mobile': '',
			this.isConfigurable ? 'configurable': ''
		];
	},
	flyerSelectorTemplate() {
      const t = this.templates;
      return t[this.config.template] || InlineFlyerSelectorDefault;
    },
	isVertical() {
			return this.flyerOrientation === 'vertical';
		},
		isConfigurable() {
			return  this.flyerOrientation === 'vertical' && this.displayMode === 'desktop' && this.flyerDrawer;
		},
		flyerDrawer() {
            return this.features.flyerSelector._flyerOrientation['+vertical']?.['_display']?.['+desktop']?.position === 'left';
		},
		isCompactView() {
			return this._config.isCompactView
		},
		isMobile() {
			return this.displayMode === 'mobile';
		},
		showList(){
			return !!this._config.isVisible;
			
		},
	},
	methods:{
		
		autoClose(){
			if(this.config.autoClose)this._config.isVisible = false;
		},

		triggerFlyerImpressions() {
			if (!this.showList) return;
			if (this.impressionFired) return;

			// filter out current flyer impression so it can be handled by flyer load to account for drawer not opened
			const sortedFlyersMinusCurrentFlyer = this.sortedFlyers.filter(flyer => flyer.title !== this.currentFlyer.title);

			sortedFlyersMinusCurrentFlyer.forEach(flyer => {
				Lytics.TriggerFlyerImpression({ 
					flyer,
					client: AppConfig.AppConf?.retailer,
					banner: AppConfig.AppConf?.title,
					store_id: this.$route.query.storeId,
					platform: this.isRaddar ? "raddar" : "client_site"
				});
			});

			this.impressionFired = true;
		}
	},
	watch: {
		isFilterOpen(val) {
    if (val) {
      // filter opened → close flyer
      this._config.isVisible = false;
    }
  },
		showList: {
			handler() {
				setTimeout(() => {
					this.triggerFlyerImpressions();
				}, 500);
			},
			immediate: true
		},
		scrollY(newValue) {
			if (newValue > 30 && this._config.shouldHide && newValue > this.lastScrollPosition && !this.isConfigurable) {
				this._config.isVisible = false;

			} else {
				this._config.shoudHide = false;
			}
			this.lastScrollPosition = newValue
		}
	}
}
</script>

<style lang="scss">
.drawer-container.left	.inline-flyer-selector.configurable {
		--drawer-open-width: 11em;
		display: flex;
		color: #fff;

		&.left{
			.flyer-list{
				width: 0px;
				&.open{
					width: var(--drawer-open-width);
				}
			}
		}
		.image-container {
			max-width: unset;
		}
		.details {
			.title {
				font-size: 0.9em;
			}
		}
	}
.inline-flyer-selector.compact-view {
	.flyer-thumb-button {
						div.thumbnail {
							border: none;
						}
					}
}
.inline-flyer-selector.vertical.compact-view {
	&.top {

		.flyer-list {
			height: 0;


			&.open {
				height: 7em;
			}

			.align-center {
				// overflow: auto;
				justify-content: center;
				display: flex;
				width: 100%;
				position: absolute;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				overflow-x: auto;
				overflow-y: hidden;

				.flyer-thumb-list {
					align-items: flex-start;
					position: unset;
					//    width: 100%;
					//   justify-content: center;
					// overflow: unset;
					overflow-x: auto;
				    overflow-y: hidden;

					.flyer-thumb-button {
						width: unset;
					}
				}

			}

		}

	}
}

.inline-flyer-selector.vertical.mobile.compact-view {
	&.top {

		.flyer-list {
			height: 0;

			&.open {
				height: 10.5em;
			}

			.align-center {
				// overflow: auto;
				justify-content: unset;


			}

			.flyer-thumb-list {
				justify-content: unset;
				.flyer-thumb-button {
						width: 11em;
					}

			}
		}

	}
}
	.inline-flyer-selector {
		--drawer-open-width: 10em;
		display: flex;
		color: #fff;
		.toggle-tab {
			position: relative;
			background-color: #333333;
			display: flex;
			writing-mode: vertical-rl;
			//column-gap: 0.5em;
			cursor: pointer;
			align-items: center;
			.caption {
				rotate: 180deg;
				font-size: 0.8em;
			}
			.rotate-chevron {
				width: 0.6em;
			}
			
		}

		.flyer-list{
			::-webkit-scrollbar{
				width: 8px;
				height: 8px;
				border-radius: 3px;
			}
			::-webkit-scrollbar-thumb{
				border-radius: 4px;
			}
			::-webkit-scrollbar-track {
				width: 8px;
				height: 8px;
			}
			::-webkit-scrollbar-track-piece{
				width: 8px;
			}
		}

		&.left{
			.flyer-list{
				width: 0px;
				&.open{
					width: var(--drawer-open-width);
				}
			}
		}
		&.top{
			flex-direction: column;
			.flyer-list{
				height: 0;
				&.open{
					height: 12em;
				}
			}
			.flyer-thumb-list {
				display: flex;
				//column-gap: 0.6em;
				padding: 0.5em;
				align-items: center;
				>* {
					margin-right: 1em !important;
				}
				.flyer-thumb-button {
					width: 12em;
					flex: none;
					margin: 0;
					height: fit-content;
				}
			}
		}

		.flyer-list {
			transition: width 0.3s cubic-bezier(0.4, 0.0, 0.2, 1), height 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
			position: relative;
			.flyer-thumb-list {
				position:absolute;
				top:0;
				bottom:0;
				left:0;
				right:0;
				overflow: auto;
				.top &{
					bottom: 0;
				}
				.left &{
					right: 0;
				}
			}

		}
		.flyer-thumb-button {
			margin: 1em;
		}
	}

</style>
